import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';

import Wrapper from '../elements/wrapper';
import { media } from '../helpers';

import { PostGridItem } from '../blog/posts-grid';

const CollectionBlogFeedContainer = styled.div`
    padding: 10vh 0;
    position: relative;
    z-index: 20;

    .title-container {
        text-align: center;
        margin-bottom: 30px;
        h3 {
            font-size: 1.5rem;
            color: #000;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            margin: 0;
        }
    }
    .blog-feed-wrapper {
        ${media.medium`max-width:82.5vw; display: flex;`}

        > * {
            flex: 0 0 33.33%;
        }
    }
`;

const CollectionBlogFeed = ({ title, handle }) => {
    const data = useStaticQuery(graphql`
        query {
            posts: allWpPost {
                edges {
                    node {
                        title
                        excerpt
                        content
                        slug
                        featuredImage {
                            node {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1000) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                        }
                        categories {
                            nodes {
                                slug
                                name
                            }
                        }
                    }
                }
            }
        }
    `);

    let posts = data?.posts.edges;

    const [currentPosts, setCurrentPosts] = useState([]);

    useEffect(() => {
        let filteredPosts = [];

        posts.map((postNode) => {
            let post = postNode.node;
            post.categories.nodes &&
                post.categories.nodes.map((category) => {
                    if (category.slug === handle) {
                        filteredPosts.push(postNode);
                    }
                });
        });

        setCurrentPosts(filteredPosts);
    }, []);

    return (
        <CollectionBlogFeedContainer>
            <Wrapper className="title-container">
                <h3>{title}</h3>
            </Wrapper>
            <Wrapper className="blog-feed-wrapper">
                {currentPosts &&
                    currentPosts.slice(0, 3).map((post, index) => {
                        return <PostGridItem post={post} key={index} />;
                    })}
            </Wrapper>
        </CollectionBlogFeedContainer>
    );
};

export default CollectionBlogFeed;
